import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'space-between',
    justifyContent: 'space-between'
  },
  galleryContainer: (disabled = false) => ({
    display: 'block',
    position: 'relative',
    width: '100%',
    height: disabled ? 0 : ['100vw', '100vw', '24.895833344vw'],
    zIndex: 0,
    overflow: 'hidden',
    ...reusables.mainTransition('height')
  }),
  container: (small = false) => ({
    position: 'relative',
    width: '100%',
    height: small ? '62.9686432vh' : '100vh',
    ...reusables.mainTransition('height'),
    p: ['16px 8px 0 16px', '16px 8px 0 16px', '24px 10px 0 24px', '24px 10px 0 24px', '24px 10px 0 24px', '40px 18px 0 40px'],
    overflow: 'hidden',
    zIndex: theme.zIndex.documentUp,
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    '.swiper-scrollbar': {
      width: '2px',
      right: 0
    },
    '.swiper-slide': {
      width: '100%',
      height: 'auto',
      pr: ['8px', '8px', '12px', '12px', '12px', '20px']
    }
  }),
  item: {
    display: 'flex',
    flexDirection: 'column',
    alingContent: 'start-flex',
    width: '100%',
    height: 'auto',
    pr: '16px',
    mb: '40px'
  },
  details: {
    font: theme.fonts.uniform,
    fontSize: theme.fontSizes.caption,
    width: '100%',
    mb: '8px',
    p: {
      fontSize: theme.fontSizes.caption,
      width: '100%',
      mb: '8px'
    },
    span: {
      width: '100%'
    },
    'span, a': {
      display: 'block',
      fontSize: theme.fontSizes.text,
      color: theme.rawColors.darkGrey700,
      mb: '8px'
    }
  },
  emailLink: {
    a: {
      textDecoration: 'underline',
      ':hover': {
        color: theme.rawColors.darkGrey700,
        ...reusables.mainTransition('color')
      }
    }
  },
  phoneLink: {
    a: {
      fontFamily: theme.fonts.uniform,
      fontSize: theme.fontSizes.h4,
      lineHeight: '140%',
      pb: '12px',
      ':hover': {
        color: theme.rawColors.darkGrey700
      }
    }
  },
  description: {
    mt: '32px',
    span: {
      fontSize: theme.fontSizes.caption,
      width: '100%',
      mb: '8px'
    }
  },
  buttonsContainer: {
    width: '100%',
    m: '4px 0 0 0',
    button: {
      mr: '8px',
      mt: '8px',
      div: {
        width: 'auto',
        ml: '8px',
        mt: '2px'
      },
      ':hover': {
        '.icon': {
          color: theme.rawColors.neutralWhite,
          svg: {
            color: theme.rawColors.neutralWhite,
            fill: theme.rawColors.neutralWhite,
            path: {
              fill: theme.rawColors.neutralWhite
            }
          }
        }
      }
    },
    a: {
      mr: '8px',
      mt: '8px',
      textDecoration: 'none',
      div: {
        width: 'auto',
        ml: '8px',
        mt: '2px'
      },
      ':hover': {
        '.icon': {
          color: theme.rawColors.neutralWhite,
          svg: {
            color: theme.rawColors.neutralWhite,
            fill: theme.rawColors.neutralWhite,
            path: {
              fill: theme.rawColors.neutralWhite
            }
          }
        }
      }
    }
  },
  buttonContainer: {
    width: '100%',
    height: 'auto',
    p: ['16px 16px', '16px 16px', '24px 24px', '24px 24px', '24px 24px', '24px 40px'],
    button: {
      width: '100%'
    },
    a: {
      width: '100%',
      textDecoration: 'none'
    }
  }
};